import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GetBrainGauge from './GetBrainGauge';

export default function BrainSubCard() {


  const age = 62
  const bioage = 57
  const diffage = age - bioage
  const warning_low = age+1;
  const warning_red = age+2;

    return(

<Grid container spacing={2} sx={{mt:2, width: '100%', bgcolor:'greydark.C500', borderRadius:'8px' }}>  

  <Grid size={5} >
            
        <Grid container sx={{ height: '100%' }}>  
            <Grid size={12} sx={{ml: 2.5, display:'flex', justifyContent:'flex-start', alignItems:'center', }}>
                <Typography variant="h4" sx={{color: 'common.white'}}> BRAIN </Typography>                                
           </Grid>
             <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start', }}>
               <Typography variant="number" sx={{color: 'traffic.green', fontWeight: 500, textAlign: 'center',
                                              ...(bioage > warning_low && {color: 'traffic.orange'}), 
                                              ...(bioage > warning_red && {color: 'traffic.red'}), 
                                        }}> 
                      {bioage} 
                   </Typography>
         </Grid>
         
       </Grid>  
  </Grid>
    
     <Grid size={7} sx={{ display:'flex' }}>
     
          <Grid container sx={{ height: '100%' }}>  
        
              <Grid size={12} sx={{display:'flex', justifyContent:'center', alignItems:'center', }}> <GetBrainGauge />   </Grid>
      
               <Grid size={12} sx={{mb:2, display:'flex', justifyContent:'center', alignItems:'flex-start', }}>
              
               <Typography variant="subtitle1" sx={{color: 'traffic.green', fontWeight: 500,
                                              ...(bioage > warning_low && {color: 'traffic.orange'}), 
                                              ...(bioage > warning_red && {color: 'traffic.red'}), 
                                        }}> 
                      {diffage} <Typography component="span" variant="subtitle1" sx={{color:'common.white'}}>  years difference <br /> to chronological age  </Typography>
                   </Typography>
         </Grid>


    </Grid>
  </Grid>

</Grid>



    
    )
}